module.exports = __webpack_public_path__ + "img/mediaImg.d5c2798e.jpg";